import React from 'react';
import { useParams } from 'react-router-dom';
import { useSparkRunByID } from 'hooks/SparkRuns/useSparkRunByID';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';
import { useStatusBarStore } from 'stores';
import { useSparksByID } from 'hooks/spark';
import useExpandAppContentConfig from 'utilities/styles';
import SparkRunSideBar from './SparkRunSideBar';
import { formatCredits } from 'utilities/index';
import { useSparkRunsStatusTypes } from 'hooks/EntityTypes/useSparkRunsStatusTypes';
import { useDialog } from 'hooks/common';
import SparkRunsHeader from 'components/SparkRuns/SparkRunsHeader';
import SparkRunOutputItem from 'components/SparkRuns/sparkRunOutput/SparkRunOutputItem';
import SparkRunningProgressScreen from 'components/SparkRuns/SparkRunningProgressScreen';

function SparkRunDetailsContainer() {
  const { id: sparkRunID } = useParams();
  const { sparkRun, sparkTasks, spark, isLoading } =
    useSparkRunByID(sparkRunID);
  const { joinedSpark, isLoading: isLoadingSpark } = useSparksByID(
    sparkRun?.attributes.sparkID
  );

  const { expandAppClasses, stylesImplemented } = useExpandAppContentConfig();
  const { open, closeDialog, openDialog } = useDialog();

  const toggleOpen = () => {
    open ? closeDialog() : openDialog();
  };

  const statusBarHeight = useStatusBarStore((state) => state.statusBarHeight);
  const { idMap } = useSparkRunsStatusTypes();

  const status = idMap?.[sparkRun?.attributes.sparkRunStatusTypeID || ''];
  const credits = formatCredits(sparkRun?.meta.credits);
  if (isLoading || isLoadingSpark) {
    return (
      <SparkRunningProgressScreen
        nodeOnly={true}
        showHeader={true}
        sparkID={sparkRun?.attributes.sparkID || ''}
        animate={false}
      />
    );
  }

  if (!sparkRunID) {
    return <></>;
  }
  return (
    <SparkScrollableGridContainer
      header={
        <SparkRunsHeader joinedSpark={joinedSpark} toggleOpen={toggleOpen} />
      }
      headerClasses={expandAppClasses.header}
      headerStyle={{
        bgcolor: 'white',
        padding: 0,
        height: '6rem',
        transition: (theme) =>
          theme.transitions.create('height', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
      }}
      height={`calc(100vh - ${statusBarHeight}px)`}
      scrollableContainerStyle={{
        position: 'relative',
        padding: 0,
        display: 'flex',
        overflow: 'hidden',
        justifyContent: 'center',
        maxWidth: '800px',
      }}
      sx={stylesImplemented}
    >
      <SparkRunSideBar
        sparkRun={sparkRun}
        spark={spark}
        credits={credits}
        status={status}
        toggleOpen={toggleOpen}
        open={open}
        sparkRunID={sparkRunID}
        sparkTasks={sparkTasks}
        statusBarHeight={statusBarHeight}
      />
      <SparkRunOutputItem
        collectiveSparkRunID={sparkRunID}
        toggleSidebar={toggleOpen}
        open={open}
      />
    </SparkScrollableGridContainer>
  );
}

export default SparkRunDetailsContainer;
